import authReducer from './authReducer';
import dmReducer from './dmReducer';
import userReducer from './userReducer';
import usersReducer from './usersReducer';
import dmimeiReducer from './dmImeiReducer';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    auth: authReducer,
    dm: dmReducer,
    dmimei: dmimeiReducer,
    userdata: userReducer,
    usersdata: usersReducer
  });
  
  export default rootReducer;